"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullOptional = void 0;
function nullOptional(value) {
    return (ctx) => {
        if (ctx.value === null || typeof ctx.value === 'undefined') {
            return {
                ok: true,
                value: null,
            };
        }
        return value(ctx);
    };
}
exports.nullOptional = nullOptional;
//# sourceMappingURL=nullOptional.js.map